import { useTranslation } from 'react-i18next';

const NAVY_MID  = '#132233';
const AMBER     = '#F5A623';
const WHITE     = '#FFFFFF';
const FONT_HEAD = "'Bebas Neue', sans-serif";
const FONT_BODY = "'DM Sans', sans-serif";

const fieldRow = { marginBottom: '10px' };
const fieldLabel = { fontSize: '0.66rem', fontWeight: 700, color: AMBER, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '3px' };
const fieldValue = { fontSize: '0.82rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.45 };

// A single trade_resources card -- shared by LicensingCerts' grid and the Trade Hub's
// licensing section, so both render identical content/styling.
// onViewTradeHub: optional -- if provided, shows a "View full trade guide" link. Omitted
// inside the Hub itself (no self-link), since trade.trade_name IS the hub's canonical key.
// compact: the Licensing & Certs grid shows only apprenticeship length, pay range and
// certifications; description and career path stay in the full trade guide (the Hub renders
// this card without compact).
export default function TradeResourceCard({ trade: tr, onViewTradeHub, compact = false }) {
  const { t } = useTranslation();
  return (
    <div style={{ backgroundColor: NAVY_MID, border: '1px solid rgba(255,255,255,0.07)', borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px', marginBottom: '8px' }}>
        <p style={{ fontFamily: FONT_HEAD, fontWeight: 400, fontSize: '1.15rem', color: WHITE, letterSpacing: '0.03em', lineHeight: 1.2, flex: 1 }}>{tr.trade_name}</p>
        {tr.category && (
          <span style={{
            backgroundColor: 'transparent', color: WHITE,
            border: '1px solid rgba(255,255,255,0.28)',
            borderRadius: '999px', fontSize: '0.62rem', fontWeight: 700, padding: '3px 9px',
            whiteSpace: 'nowrap', flexShrink: 0,
          }}>
            {tr.category}
          </span>
        )}
      </div>

      {!compact && tr.description && (
        <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.5, marginBottom: '14px' }}>{tr.description}</p>
      )}

      {tr.apprenticeship_duration && (
        <div style={fieldRow}>
          <p style={fieldLabel}>{t('resources.tradeCard.apprenticeshipLength')}</p>
          <p style={fieldValue}>{tr.apprenticeship_duration}</p>
        </div>
      )}
      {tr.pay_range && (
        <div style={fieldRow}>
          <p style={fieldLabel}>{t('resources.tradeCard.payRange')}</p>
          <p style={fieldValue}>{tr.pay_range}</p>
        </div>
      )}
      {tr.certifications_needed && tr.certifications_needed.length > 0 && (
        <div style={fieldRow}>
          <p style={fieldLabel}>{t('resources.tradeCard.certificationsNeeded')}</p>
          <p style={fieldValue}>{tr.certifications_needed.join(', ')}</p>
        </div>
      )}
      {!compact && tr.career_path && (
        <div style={{ ...fieldRow, marginBottom: onViewTradeHub ? '10px' : 0 }}>
          <p style={fieldLabel}>{t('resources.careerPath')}</p>
          <p style={fieldValue}>{tr.career_path}</p>
        </div>
      )}

      {onViewTradeHub && (
        <button
          onClick={() => onViewTradeHub(tr.trade_name)}
          style={{
            alignSelf: 'flex-start', fontSize: '0.8rem', color: AMBER, fontWeight: 700,
            background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: FONT_BODY,
            textDecoration: 'underline', textUnderlineOffset: '2px', marginTop: 'auto', paddingTop: '4px',
          }}
        >
          {t('resources.viewFullTradeGuide')}
        </button>
      )}
    </div>
  );
}
